import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Title from '../Components/Title'
import CheckList from '../Components/CheckList';
import Deck from '../Components/Deck';
import Button from '@mui/material/Button';

function Project(props){

  const mobile = useMediaQuery('(max-width:600px)');
	const theme = useTheme();

  return(
    <Grid>
      <Grid 
        container
        style={{
          height: "600px",
          width: "100vw",
          backgroundImage: `url(${props.data["headerImage"]})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Grid
          item
          xs={mobile ? 12 : 6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Box
            style={{
              height: mobile ? "256px" : "512px",
              width: mobile ? "256px" : "512px",
              backgroundImage: `url(${props.data["headerLogo"]})`,
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          display:"flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Box
          style={{
            maxWidth: mobile ? "100vw" : "50vw"
          }}
        >
          <Title
            title={props.data["title"]}
            titleColor={theme.palette.secondary.main}
            subTitle={props.data["subTitle"]}
            subTitleColor={theme.palette.secondary.main}
            id={'AssetStoreProjects'}
          ></Title>
        </Box>
      </Grid>
      <Grid
        container
        style={{
          display:"flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Box
          style={{
            maxWidth: mobile ? "100vw" : "50vw"
          }}
        >
          <Button
						href={props.data["href"]}
						style={{
							color: theme.palette.tertiary.main,
							borderRadius: 35,
							margin:"18px",
							padding: "18px 36px",
							fontSize: mobile?"14px":"20px",
							border: `3px solid ${theme.palette.tertiary.main}`,
						}}
						variant="outlined"
					>Go To Website</Button>
        </Box>
      </Grid>
      <Grid
        container
        p={2}
      >
        <Grid
          item
          p={mobile?0:5}
          xs={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: mobile?'column':'row',
            flexWrap:"wrap"
          }}
        >
          {props.data["checkList"].map((item, index)=>
            <CheckList
              key={index}
              data={item}
            ></CheckList>
          )}
        </Grid>
      </Grid>

      {props.data["images"].map((images, index)=>
        <Grid
          p={mobile?0:5}
          pt={mobile?5:0}
        >
          <Deck
            data={images}
          ></Deck>
        </Grid>
      )}
          

      <Grid
        style={{
          height:"50px"
        }}
      >
      </Grid>
    </Grid>
  )
}

export default Project;